import { render } from "./featuredBlock.vue?vue&type=template&id=746dd2b1&scoped=true"
import script from "./featuredBlock.vue?vue&type=script&lang=js"
export * from "./featuredBlock.vue?vue&type=script&lang=js"

import "./featuredBlock.vue?vue&type=style&index=0&id=746dd2b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746dd2b1"]])

export default __exports__